<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mDFziG/tc-custom/9781612433264.jpg?1695242251682" alt="This image is the cover for the book Clear Skin Detox Diet"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Clear Skin Detox Diet
      </h1>
      <p class="bookDescription body article font2">
        <b>A food-focused strategy for eliminating skin problems and creating a radiant, beautiful complexion—includes recipes and shopping lists.</b><br/>  <br/> Transform your skin by flushing toxins and fueling your body the natural way. <i>Clear Skin Detox Diet</i> shows you how to achieve the youthful, radiant complexion you desire by packing your diet with sustainable, life-force building nutrition. Rather than trying to improve your skin with harsh topical treatments, this easy-to-follow program harnesses the power of delicious whole foods so you can overcome common ailments, including:<br/>  <br/> • Wrinkles<br/> • Rashes<br/> • Eczema<br/> • Psoriasis<br/> • Acne<br/> • Rosacea<br/>  <br/> Packed with mouthwatering recipes, helpful shopping lists, and skin-clearing menu plans, this book has everything you need to get on the path to eating for radiance. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lauren Talbot
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3efb5cbc